/* No analytics scripts or storage: preserve only campaign attribution on PDP links. */
(() => {
  if (window.raviraGuideInitialized) return;
  window.raviraGuideInitialized = true;
  const incoming = new URLSearchParams(window.location.search);
  const allowed = /^(utm_[a-z0-9_]+|fbclid|gclid|gbraid|wbraid|msclkid|ttclid)$/i;
  function initialize(root) {
    if (root.dataset.guideReady) return;
    root.dataset.guideReady = 'true';
    document.querySelectorAll('a[href]').forEach((link) => {
      const destination = new URL(link.getAttribute('href'), window.location.href);
      if (destination.origin !== window.location.origin || destination.pathname !== '/products/ashwagandha-plus-1') return;
      incoming.forEach((value, key) => {
        if (allowed.test(key) && !destination.searchParams.has(key)) destination.searchParams.set(key, value);
      });
      link.href = destination.pathname + destination.search + destination.hash;
    });
    const choices = root.querySelectorAll('[data-guide-purchase]');
    const carryPurchaseChoice = () => {
      const selected = root.querySelector('[data-guide-purchase]:checked');
      if (!selected) return;
      root.querySelectorAll('[data-guide-pdp]').forEach((link) => {
        const destination = new URL(link.href, window.location.href);
        destination.searchParams.set('ravira_purchase', selected.value);
        link.href = destination.pathname + destination.search + destination.hash;
      });
    };
    choices.forEach((input) => input.addEventListener('change', carryPurchaseChoice));
    carryPurchaseChoice();
    const sticky = root.querySelector('[data-guide-sticky]');
    const studies = root.querySelectorAll('[data-guide-research]');
    const researchEnd = studies[studies.length - 1];
    if (!sticky || !researchEnd) return;
    const offer = root.querySelector('[data-guide-offer]');
    let frame = 0;
    const update = () => {
      frame = 0;
      const pastResearch = researchEnd.getBoundingClientRect().bottom <= 0;
      const bounds = offer?.getBoundingClientRect();
      const offerVisible = bounds && bounds.bottom > 0 && bounds.top < window.innerHeight;
      sticky.hidden = !pastResearch || offerVisible;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
    root.guideCleanup = () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      cancelAnimationFrame(frame);
    };
  }
  const boot = (scope = document) => scope.querySelectorAll('[data-ravira-guide]').forEach(initialize);
  boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ravira-guide]').forEach((root) => root.guideCleanup?.());
  });
})();
